module.exports = __webpack_public_path__ + "static/media/1f393.67fad046.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f393.svg
// module id = 262
// module chunks = 1